import actions from "./actions";

export const registerServiceRequest = (reqParams) => ({
  type: actions.REGISTER_SERVICE_REQUEST,
  payload: reqParams,
});

export const registerServiceSuccess = (reqParams) => ({
  type: actions.REGISTER_SERVICE_SUCCESS,
  payload: reqParams,
});

export const registerServiceFailed = (error) => ({
  type: actions.REGISTER_SERVICE_FAILURE,
  payload: error,
});

export const loginServiceRequest = (reqParams) => ({
  type: actions.LOGIN_SERVICE_REQUEST,
  payload: reqParams,
});

export const loginServiceSuccess = (reqParams) => ({
  type: actions.LOGIN_SERVICE_SUCCESS,
  payload: reqParams,
});

export const loginServiceFailed = (error) => ({
  type: actions.LOGIN_SERVICE_FAILURE,
  payload: error,
});

export const getUserByIdSuccess = (data) => ({
  type: actions.GET_USER_BY_ID_SUCCESS,
  payload: data,
});

export const getUserByIdFailed = (error) => ({
  type: actions.GET_USER_BY_ID_FAILURE,
  payload: error,
});

export const postOtpServiceRequest = (reqParams) => ({
  type: actions.POST_OTP_SERVICE_REQUEST,
  payload: reqParams,
});

export const postOtpServiceSuccess = (reqParams) => ({
  type: actions.POST_OTP_SERVICE_SUCCESS,
  payload: reqParams,
});

export const postOtpServiceFailed = (error) => ({
  type: actions.POST_OTP_SERVICE_FAILURE,
  payload: error,
});

export const getAggrementServiceRequest = (reqParams) => ({
  type: actions.GET_AGGREMENT_SERVICE_REQUEST,
  payload: reqParams,
});

export const getAggrementServiceSuccess = (reqParams) => ({
  type: actions.GET_AGGREMENT_SERVICE_SUCCESS,
  payload: reqParams,
});

export const getAggrementServiceFailed = (error) => ({
  type: actions.GET_AGGREMENT_SERVICE_FAILURE,
  payload: error,
});

export const acceptAggrementServiceRequest = (reqParams) => ({
  type: actions.ACCEPT_AGGREMENT_SERVICE_REQUEST,
  payload: reqParams,
});

export const acceptAggrementServiceSuccess = (reqParams) => ({
  type: actions.ACCEPT_AGGREMENT_SERVICE_SUCCESS,
  payload: reqParams,
});

export const acceptAggrementServiceFailed = (error) => ({
  type: actions.ACCEPT_AGGREMENT_SERVICE_FAILURE,
  payload: error,
});

export const createOtpServiceRequest = (reqParams) => ({
  type: actions.CREATE_OTP_SERVICE_REQUEST,
  payload: reqParams,
});

export const createOtpServiceSuccess = (reqParams) => ({
  type: actions.CREATE_OTP_SERVICE_SUCCESS,
  payload: reqParams,
});

export const createOtpServiceFailed = (error) => ({
  type: actions.CREATE_OTP_SERVICE_FAILURE,
  payload: error,
});
export const closeModal = () => ({
  type: actions.CLOSE_MODAL,
});